import React from "react";
import { Link } from "react-router-dom";
import Customers from '../assets/images/custumer.png'
import helpline from '../assets/images/helpline.png'
import chat from '../assets/images/chat.png'
import location from '../assets/images/location.png'
import payment from '../assets/images/payment.png'
import support from '../assets/images/support.png'

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function About() {
  return (
    <>
      {/* HEADER */}
      <div className="sub_header_in sticky_header">
        <div className="container">
          <h1>About Sparker Directory</h1>
        </div>
      </div>

      <main>
        {/* WHY CHOOSE */}
        <div className="container margin_80_55">
          <div className="main_title_2">
            <span><em /></span>
            <h2>Why Choose Sparker</h2>
            <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
          </div>

          <div className="row">
            {[
              { icon: Customers, title: "1000+ Customers",para:
                "Access a wide network of verified hotels, salons, restaurants, cafés, and shopping stores. Compare options and choose the best services with confidence."
               },
              { icon: support, title: "H24 Support",para:
                "Our dedicated support team is available round the clock to assist you with bookings, payments, or any service-related queries." },
              { icon: location, title: "100+ Locations",para:
                "We provide services across multiple cities, making it easy for you to find what you need—whether you're at home or traveling." },
              { icon: helpline, title: "Help Direct Line",para:
                "Get instant assistance through our direct helpline for quick and reliable support whenever you need it." },
              { icon: payment, title: "Secure Payments",para:
                "Enjoy safe and seamless transactions with our secure payment system supporting cards, UPI, and digital wallets." },
              { icon: chat, title: "Support via Chat",para:
                "Connect instantly with vendors or our support team through live chat for quick resolutions and real-time assistance." },
            ].map((item, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="box_feat">
                  <div className="icon_all">
                    <img src={item.icon} alt={item.icon} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>
                    {item.para}
                  
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* STORY */}
    <div className="bg_color_1">
  <div className="container margin_80_55">
    <div className="main_title_2">
      <span>
        <em />
      </span>
      <h2>Our Origins and Story</h2>
      <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
    </div>
    <div className="row justify-content-between">
      <div
        className="col-lg-6 wow animated"
        data-wow-offset={150}
        style={{ visibility: "visible" }}
      >
        <figure className="block-reveal about_us_new">
          <div className="block-horizzontal" />
          <img src="https://www.ansonika.com/sparker/img/about_1.jpg" className="img-fluid" alt="" />
        </figure>
      </div>
      <div className="col-lg-6">
        <p>
        Paar Digital Services is a dedicated hospitality membership distribution company committed to helping hotels and restaurants grow their customer base, increase repeat business, and build long-term guest loyalty. We specialize in designing, promoting, and distributing exclusive membership programs that offer customers premium benefits such as discounted stays, dining privileges, special event access, reward points, and personalized lifestyle experiences.
 
        </p>
        <p>
         
Our goal is to bridge the gap between hospitality brands and modern consumers by creating smart, value-driven membership solutions that enhance guest satisfaction while generating sustainable revenue for our partners. With a customer-first approach, innovative sales strategies, and strong market outreach, we help hotels and restaurants improve brand visibility, strengthen customer relationships, and boost occupancy as well as dining footfall.
 
        </p>
       
        {/* <p>
          <em>CEO Marc Schumaker</em>
        </p> */}
      </div>
      <div className="col-md-12">
         <p>
        
At Paar Digital Services, we believe that memberships are more than just offers—they are a powerful tool for customer retention, brand prestige, and recurring business growth. By combining digital convenience with premium hospitality experiences, we empower our partners to stand out in a competitive market and deliver exceptional value to their guests.
 
        </p>
        
      </div>
    </div>
    {/*/row*/}
  </div>
  {/*/container*/}
</div>



    
      </main>
    </>
  );
}

export default About;